export default __webpack_public_path__ + "static/media/hero-image.710150f8.png";